import Vue from 'vue';
import debounce from 'lodash.debounce';


const hotelSearch = () => {
	const el = document.getElementById('hotel-search-widget');

	if (!el) {
		return;
	}

	new Vue({
		el,
		data: {
			hotelQuery: el.querySelector('input').value,
			hotel: {},
			error: false,
			loading: false,
			results: [],
		},
		mounted() {
			if (this.hotelQuery.length > 0) {
				const request = fetch('/wp-json/ihg/v1/hotel-get?innCode=' + this.hotelQuery, {
					method: 'GET',
				});
				request.then(response => {
					return response.json();
				}).then((json) => {
					this.hotel = json;
				});
			}
		},
		methods: {
			setHotel(index) {
				const {inn_code} = this.results[index];
				this.hotelQuery = inn_code;
				this.hotel = this.results[index];
			},
			handleBlur() {
				setTimeout(() => {
					this.results = [];
				}, 500);
			},
			handleChange: debounce(function () {
				if (this.hotelQuery.length < 2) {
					this.results = [];
					return false;
				}
				this.loading = true;

				const isAdmin = el.dataset.isAdmin;
				const request = fetch('/wp-json/ihg/v1/hotel-search?isAdmin='+isAdmin+'&hotelQuery=' + this.hotelQuery, {
					method: 'GET',
				});
				request.then(response => {
					if (response.status < 300) {
						return response.json();
					} else {
						this.error = true;
						this.loading = false;
					}
				}).then((json) => {
					this.results = json.results;
					this.loading = false;
				}).catch(() => {
					this.loading = false;
					this.error = true;
				});
			}, 500),
		},
	});
};

export default hotelSearch;


// WEBPACK FOOTER //
// ./scripts/modules/hotelSearch.js